import { useConvertProject } from '@customink/project-service-react-components';

import { useCheckoutUrl } from '@/hooks/useCheckoutUrl';

export function useProceedToCheckout() {
  const [triggerProjectConvert] = useConvertProject();
  const checkoutUrl = useCheckoutUrl();

  const onProceedToCheckout = async () => {
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
      return;
    }
    triggerProjectConvert();
  };

  return onProceedToCheckout;
}
